export const parseToken = tokenJson => {
  const jwt = tokenJson && JSON.parse(atob(tokenJson.split('.')[1]));

  return {...jwt};
};
